function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

import { IndustryService } from './IndustryService';
export var ClientIndustryService = /*#__PURE__*/function (_IndustryService) {
  _inheritsLoose(ClientIndustryService, _IndustryService);

  function ClientIndustryService() {
    return _IndustryService.apply(this, arguments) || this;
  }

  var _proto = ClientIndustryService.prototype;

  _proto.getIndustries = function getIndustries() {
    return import(
    /* webpackChunkName: "industries" */
    '../consts/industries');
  };

  return ClientIndustryService;
}(IndustryService);